import { PropsWithChildren } from 'react';

import * as S from './style';
import { InlineCss } from '../types/common';

export default function ErrorMessage({ children, inlineCss }: PropsWithChildren<InlineCss>) {
  return <S.ErrorMessage inlineCss={inlineCss}>{children}</S.ErrorMessage>;
}
